import React from 'react';
import { Link } from 'react-router-dom';

import SubtleBadge from 'components/common/SubtleBadge';

import paths from 'routes/paths';
import { TIME_OPTION } from 'constants/time';

export const ADMIN_USER_LIST_COLUMNS = [
  {
    accessorKey: 'username',
    header: 'Name',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { username } = original;

      return <span>{username}</span>;
    },
  },
  {
    accessorKey: 'email',
    header: 'Email',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { id, email } = original;

      return (
        <Link to={paths.userDetails(id)}>
          <strong>{email}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'phone',
    header: 'Phone',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { phone } = original;

      return <span>{phone || '-'}</span>;
    },
  },
  {
    accessorKey: 'is_admin',
    header: 'Type',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { is_admin } = original;

      return (
        <SubtleBadge pill bg={is_admin ? 'primary' : 'secondary'}>
          {is_admin ? 'Admin' : 'Staff'}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'last_login',
    header: 'Last Login',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { last_login } = original;

      return (
        <span>{new Date(last_login).toLocaleString('en-IN', TIME_OPTION)}</span>
      );
    },
  },
  {
    accessorKey: 'is_active',
    header: 'Status',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { is_active } = original;

      return (
        <SubtleBadge pill bg={is_active ? 'success' : 'secondary'}>
          {is_active ? 'Active' : 'InActive'}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'created',
    header: 'Created',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { created } = original;

      return (
        <span>{new Date(created).toLocaleString('en-IN', TIME_OPTION)}</span>
      );
    },
  },
];
